import { createTheme, ThemeProvider } from "@material-ui/core/styles"

import Button from "@material-ui/core/Button"

import { theme as appTheme } from "components/ThemeProvider"

const theme = createTheme({
    ...appTheme,
    palette: {
        primary: {
            main: "#2c7d36",
            contrastText: "#fff"
        }
    }
})

const SuccessButton = props => {
    return (
        <ThemeProvider theme={theme}>
            <Button color="primary" {...props} />
        </ThemeProvider>
    )
}

export default SuccessButton
